module.exports = __webpack_public_path__ + "static/media/stroy.fe24676d.png";